interface keyFunc<T> {
  (arg: T): any
}

function identity<T>(val: T) {
  return val
}

export function uniquify<T>(array: Array<T>, keyFunction: keyFunc<T> = null): Array<T> {
  // Takes an array and removes duplicate items from it.  This uses the reduce function
  // on the array to visit every item in the array and add items to an accumulator
  // (another array) if they don't already exist in the accumulator.
  if (keyFunction === null) {
    keyFunction = identity
  }
  return array.reduce((accum, val) => {
    if (!accum.find((item) => keyFunction(val) === keyFunction(item))) {
      accum.push(val)
    }
    return accum
  }, [] as Array<T>)
}
